module.exports = __webpack_public_path__ + "static/media/0520-l-en.cc98cc25.png";